var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMousetrail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8261 57H-3.82609C-5.02671 57 -6 58.1739 -6 59.622V97.3781C-6 98.8261 -5.02671 100 -3.82609 100H31.8261C33.0267 100 34 98.8261 34 97.3781V59.622C34 58.1739 33.0267 57 31.8261 57Z",
    fill: "#718095",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8261 49H16.1739C14.9733 49 14 50.1466 14 51.561V88.439C14 89.8534 14.9733 91 16.1739 91H51.8261C53.0267 91 54 89.8534 54 88.439V51.561C54 50.1466 53.0267 49 51.8261 49Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8804 41H38.1196C36.949 41 36 42.1193 36 43.5V79.5C36 80.8807 36.949 82 38.1196 82H72.8804C74.051 82 75 80.8807 75 79.5V43.5C75 42.1193 74.051 41 72.8804 41Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8261 30H60.1739C58.9733 30 58 31.1466 58 32.561V69.439C58 70.8534 58.9733 72 60.1739 72H95.8261C97.0267 72 98 70.8534 98 69.439V32.561C98 31.1466 97.0267 30 95.8261 30Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.826 19H88.1739C86.9733 19 86 20.1466 86 21.561V58.439C86 59.8534 86.9733 61 88.1739 61H123.826C125.027 61 126 59.8534 126 58.439V21.561C126 20.1466 125.027 19 123.826 19Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.207 93H66.9102C66.4075 93 66 93.406 66 93.9067C66 94.4075 66.4075 94.8135 66.9102 94.8135H165.207C165.71 94.8135 166.117 94.4075 166.117 93.9067C166.117 93.406 165.71 93 165.207 93Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.136 96H69.8636C69.3867 96 69 96.4477 69 97C69 97.5523 69.3867 98 69.8636 98H163.136C163.613 98 164 97.5523 164 97C164 96.4477 163.613 96 163.136 96Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2 99H72.8C72.3582 99 72 99.4477 72 100C72 100.552 72.3582 101 72.8 101H159.2C159.642 101 160 100.552 160 100C160 99.4477 159.642 99 159.2 99Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.812 102H79.9102C79.4075 102 79 102.406 79 102.907C79 103.408 79.4075 103.813 79.9102 103.813H151.812C152.315 103.813 152.723 103.408 152.723 102.907C152.723 102.406 152.315 102 151.812 102Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.223 85H69.7623C67.1005 85 67 86.1193 67 87.5C67 88.8807 67.1005 90 69.7623 90H162.223C164.885 90 165 88.8807 165 87.5C165 86.1193 164.885 85 162.223 85Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.442 78H91.5503C90.0564 78 90 79.1193 90 80.5C90 81.8807 90.0564 83 91.5503 83H143.442C144.935 83 145 81.8807 145 80.5C145 79.1193 144.935 78 143.442 78Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.054 50.4488L112.073 35.5616C111.662 34.795 112.358 33.9055 113.201 34.12L129.75 38.3307C130.603 38.5479 130.779 39.6829 130.032 40.1486L127.107 41.9702C126.51 42.3421 126.473 43.198 127.036 43.6196L133.154 48.1989C133.603 48.5345 133.688 49.1728 133.344 49.6144L131.992 51.3475C131.652 51.7832 131.024 51.8608 130.588 51.5209L124.41 46.6987C123.858 46.2677 123.045 46.5233 122.839 47.1927L121.891 50.2705C121.63 51.1195 120.474 51.2317 120.054 50.4488Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 175,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMousetrail);
export default __webpack_public_path__ + "static/media/mousetrail.5b82e6e1d7f282daf9939ad03f6f7125.svg";
export { ForwardRef as ReactComponent };